import Head from 'next/head';

interface INextPrevLinkProps {
  currentPage?: number;
  lastPage?: number;
  baseUrl: string;
}

/**
 * Use Next and Prev links in page
 * Use this in <Head> Next component
 * @Props currentPage Current page number
 * @Props lastPage last page number
 * @Props baseUrl base url ex: 'https://maisretorno.com/baseurl'
 * @returns Next and Prev link based in current page logic
 */
export const NextPrevLink = ({
  baseUrl,
  currentPage = 1,
  lastPage,
}: INextPrevLinkProps) => {
  const nextPage = currentPage + 1;
  const prevPage = currentPage - 1;

  if (currentPage === 1 && lastPage === 1) return null;

  if (currentPage === 1) {
    return (
      <Head>
        <link rel="next" href={`${baseUrl}/page/${nextPage}`} />
      </Head>
    );
  }

  if (currentPage === 2) {
    return (
      <Head>
        <link rel="prev" href={`${baseUrl}`} />
        <link rel="next" href={`${baseUrl}/page/${nextPage}`} />
      </Head>
    );
  }

  if (currentPage === lastPage) {
    return (
      <Head>
        <link rel="prev" href={`${baseUrl}/page/${prevPage}`} />
      </Head>
    );
  }

  return (
    <Head>
      <link rel="prev" href={`${baseUrl}/page/${prevPage}`} />
      <link rel="next" href={`${baseUrl}/page/${nextPage}`} />
    </Head>
  );
};
